export enum HttpRequestHeader {
  Authorization = "Authorization",
  ApplicatioName = "Application-Name",
  RestaurantRefId = "RestaurantRefId",
}
